import { NovaPluginIds } from "panels/controls/PluginAccessPanel/constants"
import { usePluginSampleData } from "../usePluginSampleData"
import { TryAddOnItem } from "./TryAddOnItem"

export const TryAddOnItemPanorama = () => {
    const plugin = usePluginSampleData(NovaPluginIds.Panorama)
    return <TryAddOnItem plugin={plugin} />
}
